// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2HhcZ","select":"Header_select__19IIV","clinic":"Header_clinic__3aDdU"};